export enum ErrorType {
  ScriptLoadError = 'ScriptLoadError',
  FailedToLoadAllFonts = 'FailedToLoadAllFonts',
  FailedToLoadSingleFont = 'FailedToLoadSingleFont',
}
